namespace Portico.Models.Enterprise {

    export interface ISurveyAnswer {
        answerId: number;
        answerTypeId: number;
        answerValue: string;
        dtmfTone: string;
        indicatesOptIn: boolean;
        triggersFulfillment: boolean;
        requiresAdvancedNavigation: boolean;
        nextQuestionId: number;
		userName: string;
		answerCategoryId: number;
		answerCategoryCode: string;
		answerCategoryDescription: string;
    }

    export class SurveyAnswer implements ISurveyAnswer {
        answerId: number;
        answerTypeId: number;
        answerValue: string;
        dtmfTone: string;
        indicatesOptIn: boolean;
        triggersFulfillment: boolean;
        requiresAdvancedNavigation: boolean;
        nextQuestionId: number;
		userName: string;
		answerCategoryId: number;
		answerCategoryCode: string;
		answerCategoryDescription: string;

        constructor(obj?: ISurveyAnswer | any) {
            this.answerId = null;
            this.answerTypeId = null;
            this.answerValue = null;
            this.dtmfTone = null;
            this.indicatesOptIn = null;
            this.triggersFulfillment = null;
            this.requiresAdvancedNavigation = null;
            this.nextQuestionId = null;
			this.userName = null;
			this.answerCategoryId = null;
			this.answerCategoryCode = null;
			this.answerCategoryDescription = null;

            if (obj) {
				this.answerId = obj.answerId || obj.answersId || null;
                this.answerTypeId = obj.answerTypeId || null;
                this.answerValue = obj.answerValue || null;
                this.dtmfTone = obj.dtmfTone || null;
                this.indicatesOptIn = obj.indicatesOptIn || null;
                this.triggersFulfillment = obj.triggersFulfillment || null;
                this.requiresAdvancedNavigation = obj.requiresAdvancedNavigation || null;
				this.nextQuestionId = obj.nextQuestionId || null;
				this.userName = obj.userName || null;
				this.answerCategoryId = obj.answerCategoryId || null;
				this.answerCategoryCode = obj.answerCategoryCode || null;
				this.answerCategoryDescription = obj.answerCategoryDescription || null;
            }
        }
    }
}

